/* @flow */

export const random: Function = (): string => {
    return (+new Date() + Math.floor(Math.random() * 10000000)).toString(36);
};

let start: number = 1;
export const incremental = (): number => {
    return start++;
};



// WEBPACK FOOTER //
// ./src/utils/id.js